import React, {Component} from 'react';
import {
    convertToString, formQueryParams, getOrDefaultValueForCell, missingBagforStowV2
} from "../Utility";
import {getLocale} from "../handler/LocaleHandler";
import RefreshTimer from "./RefreshTimer";
import {PackageStatus} from "../enums";
import Column from "@amzn/meridian/column";
import Loader from "@amzn/meridian/loader";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {navigationAdded} from "../actions/OptionsActions";
import Link from "@amzn/meridian/link";
import {FEATURES} from "../constants";

class FloorLocationV2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "floorLocation",
            sortDirection: "ascending"
        }
    }

    render() {
        const {
            loading, stowPackageMetricsMap, inductPackageMetricsMap, stowCartMetricsMap,
            stowBagMetricsMap, stowBinMetricsMap
        } = this.props;

        const allFloorLocations = [
            ...Object.keys(stowPackageMetricsMap),
            ...Object.keys(inductPackageMetricsMap),
            ...Object.keys(stowCartMetricsMap),
            ...Object.keys(stowBagMetricsMap),
            ...Object.keys(stowBinMetricsMap)
        ];

        const distinctFloorLocations = [...new Set(allFloorLocations)];
        if (loading && !distinctFloorLocations.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }

        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), getLocale(), {numeric: true});
        }

        const sortColumn = this.state.sortColumn;
        const direction = this.state.sortDirection;
        distinctFloorLocations.sort((f1, f2) => {
            const f1CombinedMetricsMap = this.getCombinedMetricsMap(f1);
            const f2CombinedMetricsMap = this.getCombinedMetricsMap(f2);
            if (direction === "ascending") {
                return customCompare(f1CombinedMetricsMap[sortColumn], f2CombinedMetricsMap[sortColumn])
            } else {
                return customCompare(f2CombinedMetricsMap[sortColumn], f1CombinedMetricsMap[sortColumn])
            }
        });

        return (
            <Column>
                <RefreshTimer deps={[stowCartMetricsMap]} />
                <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}
                       sortColumn={this.state.sortColumn}
                       sortDirection={this.state.sortDirection}
                       onSort={onSort}
                       data-cy={"floorLocationTable"}>
                    {this.renderHeadings()}
                    {this.renderSubHeadings()}
                    {distinctFloorLocations.map((floorLocation) => this.renderFloorLocationRow(floorLocation))}
                </Table>
            </Column>
        )
    }

    renderHeadings() {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="floorLocation.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                {this.isReceivePackagesVisibilityEnabled()  && <TableCell/>}
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="floorLocation.carts" defaultMessage="Carts"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="floorLocation.bags" defaultMessage="Bags"/>
                </TableCell>
            </TableRow>
        )
    }

    renderSubHeadings() {
        return (
            <TableRow>
                <TableCell sortColumn="floorLocation">
                    <FormattedMessage id="floorLocation.floor_location" defaultMessage="Floor Location"/>
                </TableCell>
                <TableCell sortColumn="plannedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.container_planned" defaultMessage="C. Planned"/>
                </TableCell>
                {this.isReceivePackagesVisibilityEnabled() &&
                    <TableCell sortColumn="receivedPackages" alignmentHorizontal="right">
                        <FormattedMessage id="floorLocation.arrived" defaultMessage="Arrived"/>
                    </TableCell>
                }
                <TableCell sortColumn="currentInductedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell sortColumn="plannedCarts" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.planned" defaultMessage="Planned"/>
                </TableCell>
                <TableCell sortColumn="usedCarts" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.used" defaultMessage="Used"/>
                </TableCell>
                <TableCell sortColumn="missingCarts" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.missing" defaultMessage="Missing"/>
                </TableCell>
                <TableCell sortColumn="plannedBags" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.planned" defaultMessage="Planned"/>
                </TableCell>
                <TableCell sortColumn="usedBags" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.used" defaultMessage="Used"/>
                </TableCell>
                <TableCell sortColumn="missingBags" alignmentHorizontal="right">
                    <FormattedMessage id="floorLocation.missing" defaultMessage="Missing"/>
                </TableCell>
            </TableRow>
        )
    }

    renderFloorLocationRow(floorLocation) {
        const combinedMetricsMap = this.getCombinedMetricsMap(floorLocation)
        return (
            <TableRow highlightOnHover={true} key={floorLocation} onClick={() => this.floorLocationRowClicked(floorLocation)} data-cy={"floorLocationDataRow"}>
                <TableCell>{floorLocation}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {
                        combinedMetricsMap.plannedPackages
                    }
                </TableCell>
                {
                    this.isReceivePackagesVisibilityEnabled() &&
                    <TableCell alignmentHorizontal="right">
                        {
                            combinedMetricsMap.receivedPackages
                        }
                    </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.currentInductedPackages, floorLocation, PackageStatus.CURRENT_INDUCTED)
                    }
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, floorLocation, PackageStatus.STOWED)
                    }
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedCarts}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.usedCarts}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.missingCarts}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.usedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.binsMissingBag}
                </TableCell>
            </TableRow>
        )
    }

    getCombinedMetricsMap = floorLocation => {
        const {
            stowPackageMetricsMap, inductPackageMetricsMap, stowCartMetricsMap, stowBagMetricsMap, nodeResourceDataMap, stowBinMetricsMap
        } = this.props;

        return {
            floorLocation: floorLocation,
            plannedPackages: getOrDefaultValueForCell(stowPackageMetricsMap, floorLocation, "plannedPackages"),
            receivedPackages: getOrDefaultValueForCell(inductPackageMetricsMap, floorLocation, "receivedPackages"),
            currentInductedPackages: getOrDefaultValueForCell(stowPackageMetricsMap, floorLocation, "currentInductedPackages"),
            stowedPackages: getOrDefaultValueForCell(stowPackageMetricsMap, floorLocation, "stowedPackages"),
            plannedCarts: getOrDefaultValueForCell(stowCartMetricsMap, floorLocation, "plannedCarts"),
            usedCarts: getOrDefaultValueForCell(stowCartMetricsMap, floorLocation, "usedCarts"),
            missingCarts: getOrDefaultValueForCell(stowCartMetricsMap, floorLocation, "missingCarts"),
            plannedBags: getOrDefaultValueForCell(stowBagMetricsMap, floorLocation, "plannedBags"),
            usedBags: getOrDefaultValueForCell(stowBagMetricsMap, floorLocation, "usedBags"),
            binsMissingBag: missingBagforStowV2(nodeResourceDataMap, stowBinMetricsMap, floorLocation)
        }
    }

    floorLocationRowClicked = floorLocation => {
        this.props.dispatch(navigationAdded({
            key: 'FloorLocation',
            value: floorLocation
        }))
    }

    renderPackageCount = (value, floorLocation, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, floorLocation)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, floorLocation) => {
        const {navigationOptions, options} = this.props
        const params = {
            PACKAGE_STATUS: state,
            CLUSTER: navigationOptions[0].value,
            AISLE: navigationOptions[1].value,
            FLOOR_LOCATION: floorLocation
        }
        if (options.cycle) {
            params["CYCLE"] = options.cycle;
        }
        return "#packageList/?" + formQueryParams(params);
    }

    isReceivePackagesVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.IS_FLOOR_LOCATION_V2_RECEIVED_PACKAGE_VISIBILITY_ENABLED];
    }
}

const mapStateToProps = state => ({
    loading: state.floorLocationReducerV2.loading,
    navigationOptions: state.optionsReducer.navigationOptions,
    options: state.optionsReducer.options,
    stowPackageMetricsMap: state.floorLocationReducerV2.stowPackageMetricsMap,
    inductPackageMetricsMap: state.floorLocationReducerV2.inductPackageMetricsMap,
    stowCartMetricsMap: state.floorLocationReducerV2.stowCartMetricsMap,
    stowBagMetricsMap: state.floorLocationReducerV2.stowBagMetricsMap,
    nodeResourceDataMap: state.floorLocationReducerV2.nodeResourceDataMap,
    stowBinMetricsMap: state.floorLocationReducerV2.stowBinMetricsMap,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(FloorLocationV2));



// WEBPACK FOOTER //
// ./src/components/FloorLocationV2.js